<template>
<div id="secure">

    <NewTopMenu />
    <div class="container">        
        <div class="columns" style="margin-top: -50px;">
            <div class="column is-1">
                &nbsp;
            </div>
            <div class="column is-3">
                <b-notification type="is-warning" :closable="false" style="padding: 10px; font-size: 12px;">
                    <center><a v-on:click="goExternalPage()" style="text-decoration: none;">Purchase High Quality QR Card here</a></center>
                </b-notification>
            </div>
        </div>
        <div class="columns">
            <div class="column is-12">
                <div class="card is-hidden1">
                    <div class="card-header" style="padding: 10px;">
                        <datepicker @closed="getData(selectedDate,1)"  v-model="selectedDate" wrapper-class="datepicker" placeholder="Select Date" :value="selectedDate" :class="$style.datepicker" :calendar-button="true" calendar-button-icon="fa fa-calendar"></datepicker>
                        
                        <b-select id="attendanceType" name="attendanceType" v-model="attendanceType" size="is-small" style="margin-left: 10px;" @input="getData(selectedDate,1)">
                            <option selected value="1">Daily Attendance</option>
                            <option v-for="item in listItem" :key="item._id" :value="item._id">{{ item.name }}</option>
                        </b-select>
                        <loading :active.sync="isLoading1" 
                            :can-cancel="false" 
                            :is-full-page="false">
                        </loading>
                    </div>
                    <div class="card-content">
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        <div class="columns">
                            <div class="column is-8" v-on:click="goAttendanceDetails('school')">
                                <b-progress type="is-studentqr" :value=dataList.attendancePercentage size="is-large" show-value>
                                    <span style="color: black; font-size: 11px !important;">ALL ({{ dataList.attendanceCount }}/{{ dataList.studentCount }})</span>
                                </b-progress>
                            </div>
                        </div>
                        <div class="columns" v-for="kelas in dataList.classList" :key="kelas._id">
                            <div class="column is-8" v-show="kelas.tempNumber1 > 0" v-on:click="goAttendanceDetails(kelas._id)">
                                <b-progress type="is-limeGreen" :value=kelas.tempNumber3 size="is-large" show-value>
                                    <div style="color: black; font-size: 11px !important;">{{ kelas.level }} {{ kelas.name }} ({{ kelas.tempNumber2 }}/{{ kelas.tempNumber1 }})</div>
                                </b-progress>
                            </div>

                            <div class="column is-4" style="padding-top: 3px !important;" show-value v-show="kelas.tempNumber1 > 0">
                                <table class="table"><tbody>
                                    <Tr>
                                        <Td><a class="button is-info is-small" v-on:click="getMonthlyAttendance(kelas._id,kelas.level,kelas.name)">View Attendance For</a></td>
                                        <td style="padding-left: 0px !important;"><b-select id="attendanceSelectedMonth" name="attendanceSelectedMonth" v-model="attendanceSelectedMonth" size="is-small">
                                            <option selected value="1">January</option>
                                            <option selected value="2">February</option>
                                            <option selected value="3">March</option>
                                            <option selected value="4">April</option>
                                            <option selected value="5">May</option>
                                            <option selected value="6">June</option>
                                            <option selected value="7">July</option>
                                            <option selected value="8">August</option>
                                            <option selected value="9">September</option>
                                            <option selected value="10">October</option>
                                            <option selected value="11">November</option>
                                            <option selected value="12">December</option>
                                            <option selected value="202001">January 2020</option>
                                            <option selected value="202002">February 2020</option>
                                            <option selected value="202003">March 2020</option>
                                            <option selected value="202004">April 2020</option>
                                            <option selected value="202005">May 2020</option>
                                            <option selected value="202006">June 2020</option>
                                            <option selected value="202007">July 2020</option>
                                            <option selected value="202008">August 2020</option>
                                            <option selected value="202009">September 2020</option>
                                            <option selected value="2020010">October 2020</option>
                                            <option selected value="202011">November 2020</option>
                                            <option selected value="202012">December 2020</option>
                                        </b-select></td>
                                    </Tr>
                                </tbody></table>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import NewTopMenu from "./NewTopMenu";
import axios from "axios";
import { ToastProgrammatic as Toast } from 'buefy'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Datepicker from 'vuejs-datepicker';
import "./public/style.scss";

export default {
    name: "Attendance",
    components: {
        NewTopMenu,
        Loading,
        Datepicker
    },
    data() {
        return {
            dataList: [],
            isLoading: false,
            isLoading1: false,
            addContent: false,
            actionDate: '',
            selectedDate: "",
            todayDate: '',
            currentYear: 0,
            currentMonth: 0,
            currentDay: 0,
            attendanceSelectedMonth: 1,
            attendanceType: "1",  //1 is for daily attendance
            listItem: []
        };
    },
    beforeMount() {
        this.$emit("authenticated", true);
        console.log("before mount hoho");
    },
    created() {
        var currentDate = new Date();
        this.currentDay = currentDate.getDate();
        if (currentDate.getDate() < 10){
            this.currentDay = "0" + this.currentDay;
        }
        this.currentYear = currentDate.getFullYear()
        this.currentMonth = currentDate.getMonth()// + 1;  //since month starts from 0
        this.attendanceSelectedMonth = this.currentMonth + 1
        if (this.currentMonth < 10){
            this.currentMonth = "0" + this.currentMonth;
        }
        this.actionDate = currentDate.getFullYear() + "" + this.currentMonth + "" + this.currentDay;
        console.log("124 this.actionDate: " + this.actionDate)
        this.getData(this.actionDate,0)
        this.getSubjectAttendance()
    },
    mounted(){
    },
    methods: {
        getData(getActionDate,caller){
            let self = this;
            self.isLoading = true;

            if (caller == 1){   //called by datepicker
                console.log("119 getActionDate: " + getActionDate)
                var setActionDate = "";
                var setMonth = getActionDate.getMonth() + 1
                var setDay = getActionDate.getDate();
                if (setMonth < 10){
                    setMonth = "0" + setMonth
                }
                if (setDay < 10){
                    setDay = "0" + setDay
                }
                console.log("setMonth: " + setMonth)
                console.log("setDay: " + setDay)
                setActionDate = getActionDate.getFullYear() + "" + setMonth + "" + setDay
                getActionDate = setActionDate
            }else{
                console.log("year: " + self.currentYear + " day: " + self.currentDay + " mo: " + self.currentMonth)
                var setMonth = parseInt(self.currentMonth) + 1
                if (setMonth < 10){
                    setMonth = "0" + setMonth
                }
                this.selectedDate = new Date(self.currentYear, self.currentMonth,self.currentDay )
                getActionDate = self.currentYear + "" + setMonth + "" + self.currentDay
            }
            console.log("178 getActionDate: " + getActionDate)
            console.log("178 self.attendanceType: " + self.attendanceType)
            this.actionDate = getActionDate
            
            this.$gtag.event('attendance', {
                'event_category': 'list',
                'event_label': localStorage.getItem('schoolName'),
                'value': localStorage.getItem('schoolID')
            })

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/attendance/list', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                actionDate: getActionDate,
                displayEachClass: true,
                attendanceType: self.attendanceType
            })
            .then(response => {
                self.dataList = response.data
                self.isLoading = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading = false
            })
        },   
        getSubjectAttendance(){
            let self = this;
            self.isLoading1 = true;

            axios.defaults.responseType = 'json'
            axios.post(process.env.NEW_ENDPOINT + '/behaviors/list/', {
                token: localStorage.getItem('jwtTokenV2'),
                email: localStorage.getItem('email'),
                dataType: 5
            })
            .then(response => {
                self.listItem = response.data
                self.isLoading1 = false
            })
            .catch(e => {
                console.log(e)
                self.isLoading1 = false
            })
        },
        goExternalPage(){
            var url = "https://purchaseQRcard.wasap.my";
            window.open(url, '_blank');
        },      
        getMonthlyAttendance(kelasID,kelasLevel,kelasName){
            kelasName = kelasLevel + " " + kelasName
            var url;
            if (this.attendanceSelectedMonth > 12){
                var getYear = this.attendanceSelectedMonth.substring(0,4)
                var getMonth = this.attendanceSelectedMonth.substring(4)
                url = "https://attendance.studentqr.com/#/?year=" + getYear + "&month=" + parseInt(getMonth) + "&email=" + localStorage.getItem('email') + "&password=" + encodeURIComponent(sessionStorage.getItem('userLogin')) + "&userType=2&kelasID=" + kelasID + "&kelasName=" + kelasName + "&teacherName=admin";
            }else{
                url = "https://attendance.studentqr.com/#/?year=" + this.currentYear + "&month=" + this.attendanceSelectedMonth + "&email=" + localStorage.getItem('email') + "&password=" + encodeURIComponent(sessionStorage.getItem('userLogin')) + "&userType=2&kelasID=" + kelasID + "&kelasName=" + kelasName + "&teacherName=admin";
            }
            window.open(url, '_blank');
        },
        goAttendanceDetails(kelasID){
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_CATEGORY',kelasID)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_ATTENDANCE_TYPE',this.attendanceType)
            this.$store.commit('UPDATE_VIEW_SUBMISSIONS_DURATION_DAILY',this.actionDate)
            localStorage.setItem('VIEW_SUBMISSIONS_CATEGORY',kelasID)
            localStorage.setItem('VIEW_SUBMISSIONS_ATTENDANCE_TYPE',this.attendanceType)
            localStorage.setItem('VIEW_SUBMISSIONS_DURATION_DAILY',this.actionDate)
            this.$router.push({
                name: "AttendanceDetails"
            });
        },
        goManageClasses(){
            this.$router.push({
                name: "ManageClassesHome"
            });
        },
        goManageTeachers(){
            this.$router.push({
                name: "ManageTeachersHome"
            });
        },
        goManageBehaviors(){
            this.$router.push({
                name: "ManageBehaviorsHome"
            });
        },
        goManageBadges(){
            this.$router.push({
                name: "ManageBadgesHome"
            });
        }
    },
};
</script>

<style scoped>
.datepicker{
    margin-left: 30px;
}
.container{
    padding: 10px;
}
.box{
    border: 1px solid #ccc;
    width: 40% !important;
    margin: 4px;
    padding: 0px !important;
}
.active{
    border: 1px solid rgb(6, 50, 247);
}
</style>
<style module>
.datepicker input{
    border: none; /* <-- This thing here */
    border:1px solid #1849c8;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    height: 29px;
}
</style>



// WEBPACK FOOTER //
// src/components/Attendance.vue